/**
 * src/router/index.js
 * Universal router with smart iframe detection and auto-redirection
 */
import { createRouter, createWebHistory } from 'vue-router'

import HomeView from '../views/HomeView.vue'
const PreviewView = () => import('../views/PreviewView.vue')

/**
 * Detects whether the current window is running embedded within an iframe
 * @returns {boolean}
 */
export function isRunningInIframe() {
  if (typeof window === 'undefined') return false
  try {
    return window.self !== window.top
  } catch {
    // Cross-origin access blocked to window.top => definitely inside an iframe!
    return true
  }
}

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/preview',
    name: 'preview',
    component: PreviewView,
    props: { isIframe: false }
  },
  {
    path: '/iframe/preview',
    name: 'iframe-preview',
    component: PreviewView,
    props: { isIframe: true }
  },
  // Fallback / redirect
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Smart Security & Context-Aware Navigation Guard
router.beforeEach((to, from, next) => {
  const inIframe = isRunningInIframe()

  // 1. If user opened /iframe/... directly in browser (NOT inside an iframe):
  // Automatically redirect to '/'
  if (to.path.startsWith('/iframe') && !inIframe) {
    console.warn('[RouterGuard] Direct browser access to iframe route detected. Redirecting to /')
    return next({ path: '/' })
  }

  // 2. If running inside an iframe, must use /iframe/preview route
  if (inIframe) {
    if (to.path === '/preview') {
      console.info('[RouterGuard] Embedded inside iframe. Redirecting /preview to /iframe/preview')
      return next({ path: '/iframe/preview', query: to.query, hash: to.hash })
    }
    if (to.path === '/') {
      if (to.query.url) {
        return next({ path: '/iframe/preview', query: to.query, hash: to.hash })
      }
    }
  }

  next()
})

export default router
